import { useRef, useEffect, useCallback } from "react";

export const useAutoHeight = (text, isMain = false, dependencies = []) => {
  const textAreaRef = useRef(null);

  const adjustHeight = useCallback(() => {
    const textarea = textAreaRef.current;
    if (textarea) {
      const minHeight = isMain ? 120 : 80;
      
      // 🔥 스크롤 위치 저장
      const scrollTop = textarea.scrollTop;
      const scrollLeft = textarea.scrollLeft;
      
      // 높이를 auto로 리셋하여 실제 필요한 높이 재계산
      textarea.style.height = 'auto';
      
      // scrollHeight 기반으로 새로운 높이 설정
      const scrollHeight = textarea.scrollHeight;
      textarea.style.height = Math.max(scrollHeight, minHeight) + 'px';
      
      // 🔥 스크롤 위치 복원
      textarea.scrollTop = scrollTop;
      textarea.scrollLeft = scrollLeft;
    }
  }, [isMain]);

  // text 변경 시에만 높이 조정
  useEffect(() => {
    adjustHeight(); // ← 여기서 style.height 변경 → 스크롤 리셋!
  }, [text, adjustHeight, ...dependencies]);

  return { textAreaRef, adjustHeight };
}; 